import Breadcrumb from "@/components/base/Breadcrumb";
import ContactForm from "./components/ContactForm";
import usePageMeta from "@/hooks/usePageMeta";
import { contactInfo, socialLinks } from "@/mocks/site";

const infoItems = [
  { icon: "ri-mail-line", label: "官方邮箱", value: contactInfo.email },
  { icon: "ri-weibo-line", label: "官方微博", value: contactInfo.weibo },
  { icon: "ri-map-pin-line", label: "工作室地址", value: contactInfo.address },
  { icon: "ri-time-line", label: "回复时间", value: "工作日 10:00 - 18:00（演示）" },
];

export default function Contact() {
  usePageMeta({
    title: "联系森泽佳奈 - 官方联络与留言",
    description:
      "通过官方邮箱、社交平台或在线留言与森泽佳奈的官方团队取得联系，获取合作与媒体沟通渠道。",
    keywords: "森泽佳奈联系,森泽佳奈官方,森泽佳奈合作,森泽佳奈留言",
  });

  return (
    <div className="bg-background-50">
      <section className="bg-background-100 border-b border-background-200">
        <div className="px-4 md:px-8 py-8 md:py-10">
          <Breadcrumb items={[{ label: "联系" }]} />
          <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-4">
            联系我们
          </h1>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-2xl">
            无论是粉丝来信、媒体采访还是合作洽谈，都可以通过以下方式与森泽佳奈的官方团队取得联系。
          </p>
        </div>
      </section>

      <section className="px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          <div>
            <h2 className="font-heading text-xl font-semibold text-foreground-950 mb-5">
              联系方式
            </h2>
            <ul className="flex flex-col gap-4">
              {infoItems.map((item) => (
                <li
                  key={item.label}
                  className="flex items-start gap-4 p-4 rounded-lg bg-background-100 border border-background-200"
                >
                  <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 shrink-0">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <span className="flex flex-col">
                    <span className="text-xs text-foreground-500">{item.label}</span>
                    <span className="text-sm text-foreground-900 mt-0.5 break-all">{item.value}</span>
                  </span>
                </li>
              ))}
            </ul>

            <div className="mt-6 p-5 rounded-lg bg-accent-100 border border-accent-200">
              <h3 className="font-medium text-accent-900 flex items-center gap-2 mb-2">
                <i className="ri-information-line"></i>
                使用须知
              </h3>
              <p className="text-sm text-accent-900/90 leading-relaxed">{contactInfo.notice}</p>
            </div>
          </div>

          <ContactForm />
        </div>
      </section>

      <section className="px-4 md:px-8 py-10 md:py-14 bg-background-100">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
          关注官方社交平台
        </h2>
        <p className="text-sm text-foreground-600 mb-6">
          扫描二维码或点击链接，第一时间获取最新动态（以下二维码为演示样式，不可扫描）。
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {socialLinks.map((s) => (
            <a
              key={s.name}
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex flex-col items-center gap-4 p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <span className="w-28 h-28 flex flex-col items-center justify-center gap-2 rounded-md bg-background-100 border border-background-200 text-foreground-400">
                <i className={`${s.icon} text-4xl text-primary-500`}></i>
                <span className="text-[10px] tracking-wide">演示二维码</span>
              </span>
              <span className="flex items-center gap-1.5 text-sm text-foreground-800 group-hover:text-primary-600 transition-colors">
                {s.name}
                <i className="ri-external-link-line text-xs"></i>
              </span>
            </a>
          ))}
        </div>
      </section>

      <section className="px-4 md:px-8 py-10 md:py-14">
        <div className="p-6 md:p-8 rounded-lg bg-primary-900 text-background-100">
          <h2 className="font-heading text-lg md:text-xl font-bold text-background-50 mb-3">
            版权声明
          </h2>
          <p className="text-sm text-background-300 leading-relaxed">
            {contactInfo.notice}
            本站出现的所有名称、作品、时间与联络信息均为演示示例，不对应任何真实个人或组织。若您希望将该站点用于实际用途，请替换为真实、合规的内容与数据。
          </p>
        </div>
      </section>
    </div>
  );
}